import { Component, EventEmitter } from '@angular/core';
import { ArticleComponentsPresenter } from '@admintool/components/presenter/article-components.presenter';

@Component({
  standalone: false,
  selector: 'app-mounting-rail-assistant-base-settings',
  templateUrl: './mounting-rail-assistant-base-settings.component.html',
})
export class MountingRailAssistantBaseSettingsComponent {
  public constructor(
    private articleComponentsPresenter: ArticleComponentsPresenter
  ) {}

  public finish = new EventEmitter<void>();

  public close(): void {
    this.finish.emit();
  }

  public openEditArticleNumberMappingDialog(): void {
    this.articleComponentsPresenter.openEditArticleNumberMappingDialog();
  }
}
